import { render } from "./Landing.vue?vue&type=template&id=6bb46e02&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=6bb46e02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bb46e02"

export default script